export default __webpack_public_path__ + "static/soehne-mono-web-buch-kursiv-f557f0c331bac4bde4e350d9233e1cc8.woff2";